export default __webpack_public_path__ + "static/media/logoSGNCapitalDark.cc81e03b.png";